import DialogAlertForwaredRef, { useDialogAlert } from '@app/components/DialogAlert';
import { useClientArea } from '@app/contexts/ClientArea';
import { OnlyOnOrder } from '@app/stories/FooterLabel.stories';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons';
import React, { ChangeEvent } from 'react';
import { Container, BottomBox, TopBox } from './styles';
import { CheckboxLabel } from '@app/components/Global';
import { useRestaurantContext } from '../context';

type Props = {
  onlyRegisterOrder: boolean;
  onOnlyRegisterOrderChange: (value: boolean) => void;
};

export default function ClientLoginIndicator({ onlyRegisterOrder, onOnlyRegisterOrderChange }: Props) {
  const { primaryColor } = useRestaurantContext();
  const { client, logOut } = useClientArea();
  const { dialogRef, DialogAlert } = useDialogAlert();

  async function handleDiconnectClick() {
    const buttonPressed = await dialogRef.current?.choose({
      title: 'Aviso',
      message: 'Tem certeza que deseja sair?',
      buttons: [{ text: 'Cancelar' }, { text: 'Desconectar', dataCy: 'dialog-alert-disconnect-choose' }],
    });

    if (buttonPressed?.text === 'Desconectar') logOut();
  }

  function handleChangeCheckbox(event: ChangeEvent<HTMLInputElement>) {
    onOnlyRegisterOrderChange(event.target.checked);
  }

  return (
    <Container data-cy="client-login-indicator">
      <TopBox>
        <span>Conectado como {client?.NomeFantasia}</span>
        <button onClick={handleDiconnectClick} data-cy="client-login-indicator-disconnect-btn">
          <span>Desconectar</span>
          <ExitToApp style={{ color: '#fff' }} />
        </button>
      </TopBox>
      <BottomBox>
        <FormControlLabel
          control={
            <Checkbox style={{ color: primaryColor }} checked={onlyRegisterOrder} onChange={handleChangeCheckbox} />
          }
          label={<CheckboxLabel>Apenas registrar o pedido (não enviar para o WhatsApp)</CheckboxLabel>}
          data-cy="checkbox-only-register-order"
        />
      </BottomBox>
      {DialogAlert}
    </Container>
  );
}
